import { Shield } from "lucide-react";
import { type QuizConfig } from "~/types/quiz";

export const otpornostNaStres: QuizConfig = {
  id: "otpornost-na-stres",
  illustration: {
    src: "/images/quizzes/otpornost-na-stres.webp",
    alt: "Muškarac vezuje cipelu na stazi posle kiše i sprema se da nastavi.",
  },
  lastModified: "2026-10-05",
  title: "Koliko si otporan/na na stres?",
  shortTitle: "Otpornost na stres",
  description:
    "Otkrij koliko si sposoban/na da se nosiš sa stresnim situacijama i kako da poboljšaš svoju otpornost.",
  longDescription:
    "Ovaj test otkriva koliko su tvoja snaga, fleksibilnost i navike zaista spremne da izdrže svakodnevne pritiske. Procenićemo koliko brzo se vraćaš u balans nakon krize, koje strategije koristiš i gde postoje pukotine koje iscrpljuju tvoju energiju. Na kraju dobijaš jasan pregled mentalnih i fizičkih signala koji ti govore da je vreme za pauzu, zajedno sa praktičnim taktikama za jačanje otpornosti i održavanje fokusa kada nastupi haos.",
  icon: Shield,
  duration: "4-6 min",
  category: "Stres i burnout",
  focusAreasWanted: [
    "stress",
    "emotional_regulation",
    "self_development",
    "burnout",
  ],
  questions: [
    {
      type: "radio",
      question:
        "Kada se suočiš sa stresnom situacijom, koliko brzo se oporaviš?",
      options: [
        "Veoma brzo",
        "Relativno brzo",
        "Treba mi vremena",
        "Teško se oporavljam",
        "Dugo ostajem pod utiskom",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje strategije koristiš kada se suočavaš sa stresom? (označi sve što važi)",
      options: [
        "Tražim podršku od drugih",
        "Fokusiram se na rešavanje problema",
        "Praktikujem tehnike relaksacije",
        "Bavim se fizičkom aktivnošću",
        "Reorganizujem prioritete",
        "Izbegavam probleme",
        "Nemam posebne strategije",
      ],
      scores: [1, 1, 1, 1, 1, 0, 0],
    },
    {
      type: "radio",
      question: "Koliko često uspevaš da održiš produktivnost uprkos stresu?",
      options: ["Uvek", "Često", "Ponekad", "Retko", "Nikad"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "radio",
      question: "Da li uspevaš da zadržiš optimizam u teškim situacijama?",
      options: ["Da, uvek", "Uglavnom da", "Ponekad", "Retko", "Ne"],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje od sledećih karakteristika te opisuju? (označi sve što važi)",
      options: [
        "Lako se prilagođavam promenama",
        "Imam jasne životne ciljeve",
        "Učim iz teških iskustava",
        "Imam dobar sistem podrške",
        "Verujem u svoje sposobnosti",
        "Teško mi je da se nosim sa promenama",
      ],
      scores: [1, 1, 1, 1, 1, 0],
    },
    {
      type: "textarea",
      question:
        "Opiši situaciju kada si pokazao/la veliku otpornost na stres. Šta ti je pomoglo?",
    },
    {
      type: "radio",
      question: "Kako reaguje tvoje telo na stresne situacije?",
      options: [
        "Uglavnom ne osećam fizičke promene",
        "Ponekad imam blage simptome (glavobolja, umor)",
        "Često imam fizičke reakcije",
        "Imam jake fizičke reakcije",
        "Fizičke reakcije mi otežavaju funkcionisanje",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Šta radiš kada osećaš da ti je previše svega? (označi sve što važi)",
      options: [
        "Odvojim vreme samo za sebe",
        "Pričam sa nekim bliskim",
        "Izađem u prirodu",
        "Meditiram ili vežbam disanje",
        "Spavam više nego inače",
        "Jedem više nego inače",
        "Povlačim se od drugih",
      ],
      scores: [1, 1, 1, 1, 0, 0, 0],
    },
    {
      type: "radio",
      question: "Koliko često primećuješ da ti stres utiče na san?",
      options: [
        "Skoro nikad",
        "Retko, samo kad sam baš pod pritiskom",
        "Povremeno imam problema sa spavanjem",
        "Često ne spavam dobro",
        "Stalno imam problema sa snom",
      ],
      scores: [4, 3, 2, 1, 0],
    },
    {
      type: "checkbox",
      checkboxScoring: "sum",
      question:
        "Koje su tvoje jake strane u teškim situacijama? (označi sve što važi)",
      options: [
        "Ostajam pribran/a",
        "Brzo smišljam rešenja",
        "Dobro organizujem svoje vreme",
        "Znam kad mi treba pauza",
        "Umem da tražim pomoć",
        "Lako se fokusiram na bitno",
        "Teško mi je da prepoznam svoje jake strane",
      ],
      scores: [1, 1, 1, 1, 1, 1, 0],
    },
  ],
  copy: {
    title: "Procena otpornosti na stres",
    subtitle: "Tvoja sposobnost suočavanja sa izazovima",
    scoreLabel: "Tvoj nivo otpornosti na stres:",
    adviceTitle: "Saveti za jačanje otpornosti",
    resourcesTitle: "Korisni resursi za tebe:",
    whatNextTitle: "Šta dalje?",
    shareButtonText: "Podeli rezultat",
  },
};
